import { ProcessingFacilityFieldEnums } from "enums/ProcessingFacilityEnums";
import { ProductDistributionProps } from "enums/ProductDistributionEnums";
import { FormikContextType } from "formik";
import { ProductDistributionFormData } from "models/ProductDistributionFormData/ProductDistributionFormData.model";

export const validateForHandleSave = async (formikProps: FormikContextType<ProductDistributionFormData>, handleSaveAsDraft?: (payload: ProductDistributionFormData) => void) => {
  const { validateForm, values, setFieldTouched } = formikProps;
  const isValidated = await validateForm();

  if (isValidated.productDistributionRoute?.length) {
    Array.isArray(isValidated.productDistributionRoute) &&
      isValidated.productDistributionRoute.forEach((_, index) => {
        setFieldTouched(`${ProductDistributionProps.PRODUCT_DISTRIBUTION_ROUTES}[${index}].${ProcessingFacilityFieldEnums.END_MARKET_LOCATION_NAME}`, true, true)
        setFieldTouched(`${ProductDistributionProps.PRODUCT_DISTRIBUTION_ROUTES}[${index}].${ProcessingFacilityFieldEnums.UNITS_NAME}`, true, true)
      })
  }
  if (Object.keys(isValidated).length === 0) {
    handleSaveAsDraft?.(values);
  }
}